import { api } from '@/services';

import { ROLES_API_ENDPOINTS } from '@/constants';
import { ApiResponse, CursorPagedResponse, IdNamePair, PagedResponse } from '@/types';
import {
  IRoleAssignmentDetails,
  IRoleAssignment,
  IRoleAssignmentSearchingPayload,
} from '@/features/role-assignments/interfaces';
import { IOption } from '@/interfaces';

const RoleAssignmentService = {
  GetRoleAssignment: async (id: string): Promise<ApiResponse<IRoleAssignmentDetails>> => {
    const response = await api.get(ROLES_API_ENDPOINTS.ROLES_ASSIGNMENTS_ID.replace(':id', id));
    return response.data;
  },
  GetRoles: async (): Promise<ApiResponse<IOption[]>> => {
    const response = await api.post<ApiResponse<CursorPagedResponse<IdNamePair>>>(
      ROLES_API_ENDPOINTS.ROLES_CURSOR,
      {},
    );
    const mappedResponse = response.data.data.data.map((item) => ({
      label: item.name,
      value: item.id,
    }));
    return {
      ...response.data,
      data: mappedResponse,
    };
  },
  RolesSearching: async (
    payload: IRoleAssignmentSearchingPayload,
  ): Promise<PagedResponse<IRoleAssignment>> => {
    const response = await api.post<ApiResponse<PagedResponse<IRoleAssignment>>>(
      ROLES_API_ENDPOINTS.ROLES_ASSIGNMENTS_SEARCHING,
      payload,
    );
    return response.data.data;
  },
};

export default RoleAssignmentService;
